<template>
  <div class="gate">
    <div class="gate-item">
      <div class="title">
        <span class="title-text">{{gateData.nodeName}}</span>
      </div>
      <div class="content">
        <div class="content-item">
          <img class="content-img" src="@/assets/image/index/在岗人数@2x.png" />
          <span class="content-count">{{gateData.onLineWorkerNum}}</span>
          <span class="content-des">实时在岗人数（人）</span>
        </div>
        <div class="content-item">
         <div class="count"> {{gateData.inRecordNum}} <div class="successtag">进场</div></div>
         <div  class="count"> {{gateData.outRecordNum}} <div class="warningtag">退场</div></div>
          <span class="content-des">实时在岗人数（人）</span>
        </div>
        <div class="content-item">
          <img class="content-img" src="@/assets/image/index/设备@2x.png" />
          <span class="content-count">{{gateData.relateEquNum}}</span>
          <span class="content-des">关联设备数</span>
        </div>
      </div>
    </div>
    <div class="gate-item">
      <div class="title">
        <span class="title-text">通道监控</span>
      </div>
      <div class="vedio-detail">
        <div style="width: 375px;height: 220px;" v-for="item in channelList"> 
          <vidobox :showBottom="false" :imgUrl ='item.imageUrl' :id= "'vedios'+item.channelId" :url="item.liveUrl" :list="item" :kbottom="'0px'"
          width="375" height="220" :kheight="'40px'" :token="item.token" />
        </div>
      
       </div>
    </div>
    <div class="gate-item">
      <div class="title">
        <span class="title-text">物联网设备</span>
      </div>
      <div class="content-detail">
        <div v-for="item in equipmentData" >
          <div class="row mt-16" >
           <div class="name">
            <img class="name-img" :src="iconMap[item.type]" alt="">
              {{ item.number }}
           </div>
            <div class="link" @click="detailClick(item)">
              查看详情
              <div class="arrow" :class="item.id===selectItem.id?'rotate-arrow':''"></div>
            </div>
           
          </div>
          <div v-if="item.id===selectItem.id" class="card">
              <div class="el-row">
                <div class="el-col-12">设备名称</div>
                <div class="el-col-12">{{ selectItem.deviceName }}</div>
              </div>
              <div class="el-row">
                <div class="el-col-12">设备编号</div>
                <div class="el-col-12">{{ selectItem.number }}</div>
              </div>
              <div class="el-row">
                <div class="el-col-12">设备型号</div>
                <div class="el-col-12">{{ selectItem.model }}</div>
              </div>
              <div class="el-row">
                <div class="el-col-12">设备类型</div>
                <div class="el-col-12">{{ selectItem.type }}</div>
              </div>
              <div class="el-row">
                <div class="el-col-12">设备类别</div>
                <div class="el-col-12">{{ selectItem.minorType }}</div>
              </div>
              <div class="el-row">
                <div class="el-col-12">设备状态</div>
                <div class="el-col-12"><div class="tag">{{selectItem.status}}</div></div>
              </div>
          </div>
          <el-divider style="margin-top: 16px;"></el-divider>
        </div>
       
       </div>
    </div>
  </div>
</template>
<script>
import {getRealNameData} from '@/utils/indexApi'
import vidobox from '../common/vidobox.vue';
export default {
  components: { vidobox },
  props:{
    id:{
      type:Number,
      default(){
        return ""
      }
    }
  },
  data() {
    return {
      gateData:{},
      equipmentData:[{
        type:'球机',
        name:'一号东大门-4号球机',
        id:1
      }],
      channelList:[],
      iconMap:{
        '枪机':require( '@/assets/image/index/枪机.png'),
        '球机':require( '@/assets/image/index/球机.png'),
        '实名制':require('@/assets/image/index/闸机.png')
      },
      selectItem:{}
    }
  },
  methods: {
    detailClick(item){
      this.selectItem = item
    },
    //获取闸机数据
    getGateData(){
      getRealNameData(this.id).then(res=>{
        this.gateData = res.data
        this.channelList = this.gateData.channelList
        this.equipmentData = this.gateData.equipmentList
      })
    },
  },
  created(){
    this.getGateData()
  }
}
</script>
<style scoped lang="scss">
.mt-16{
  margin-top: 16px;
}
.el-divider{
  background: #BBC6D6;
  opacity: 0.3;
}
.el-row{
  margin-bottom: 14px;
}
.title {
  width: 236px;
  height: 26px;
  background: url('@/assets/image/index/二级标题-背景@2x.png');
  background-size: contain;

  .title-text {
    margin-left: 32px;
    font-family: AlibabaPuHuiTi_2_75_SemiBold;
    font-size: 18px;
    color: #D1D6DF;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    // background: linear-gradient(270deg, #ACDDFF 0%, #FFFFFF 100%);
  }
}

.gate {
  .gate-item {
    margin-bottom: 28px;
  }

  .card {
    margin-top: 16px;
    padding: 10px 16px;
    width: 410px;
    background: rgba(0, 25, 49, 0.5);
    box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
    border-radius: 8px;
    border: 1px solid rgba(131, 166, 199, 0.3);
    backdrop-filter: blur(14px);

    .card-tab {
      display: flex;
      align-items: center;
      height: 40px;
      border-bottom: 1px solid rgba(131, 166, 199, 0.3);

      .tab-item {
        width: 80px;
        line-height: 40px;
        text-align: center;
      }

      .activeTab {
        background: url('@/assets/image/index/光效.png');
        background-size: contain
      }
    }

    .card-pic {
      height: calc(100% - 40px);
    }
  }
  .tag{
    width: 50px;
    height: 20px;
    background: linear-gradient( 56deg, #00B4FB 0%, #0254A0 100%);
    border-radius: 4px;
    padding:0 7px ;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
  }
  .row{
      display: flex;
      align-items: center;
      justify-content: space-between; 
      .name{
        display: flex;
        align-items: center;
        .name-img{
          width: 16px;
          height: 16px;
          margin-right: 2px;
        }
      }
      .link{
        display: flex;
        align-items: center;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-size: 15px;
        color: #00C1FF;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        .arrow{
          width: 0;
          height: 0;
          margin-left: 8px;
          border: 10px solid transparent;
          border-right: 10px solid #849DB3FF;
          transform: rotateZ(-90deg) translateX(-5px);
        }
        .rotate-arrow{
          transform: rotateZ(90deg) translateX(-5px);
        }
      }
     
  }
  .content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 13px;
    margin-top: 16px;
   
    .content-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 128px;
      height: 120px;
      padding: 9px 0;
      background: url('@/assets/image/index/数字／匡备份@2x.png') no-repeat;
      background-size: contain;
      .count{
        display: flex;
        align-items: center;
        gap: 14px;
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 22px;
        color: #D9E7FF;
        line-height: 24px;
        text-align: right;
        font-style: normal;
        text-transform: none;
        .warningtag{
         
          width: 43px;
          height: 20px;
          line-height: 20px;
          background: linear-gradient( 56deg, #F0B964 0%, #9C5C15 100%);
          border-radius: 4px;
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: 12px;
          color: #FFFFFF; 
          text-align: center;
          font-style: normal;
        }
        .successtag{
        
          width: 43px;
          height: 20px;
          line-height: 20px;
          background: linear-gradient( 56deg, #00B4FB 0%, #0254A0 100%);
          border-radius: 4px;
          font-family: AlibabaPuHuiTi_2_85_Bold;
          font-size: 12px;
          color: #FFFFFF;
          text-align: center;
          font-style: normal;
        }
      }
    .content-img {
        width: 60px;
        height: 50px;
      }

      .content-count {
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 22px;
        color: #D9E7FF;
        line-height: 22px;
        text-align: right;
        font-style: normal;
        text-transform: none;
      }

      .content-des {
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-size: 12px;
        color: #D9E7FF;
        line-height: 13px;
        text-align: right;
        font-style: normal;
        text-transform: none;
      }

    }

  }
}
 .card {
    margin-top: 16px;
    width: 410px;
    background: rgba(0, 25, 49, 0.5);
    box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
    border-radius: 8px;
    border: 1px solid rgba(131, 166, 199, 0.3);
    backdrop-filter: blur(14px);
}
.vedio-detail{
 max-height: 450px;
  overflow: auto;
  margin-top:16px;
  display:flex;
  flex-direction: column;
  align-items: center;
  gap:16px;
}
.content-detail{
  max-height: 300px;
  overflow: auto;
}
</style>